'use client';
import { cloneElement, isValidElement, } from 'react';
function mergeRefs(...refs) {
    return (value) => {
        for (const ref of refs) {
            if (typeof ref === 'function')
                ref(value);
            else if (ref && 'current' in ref)
                ref.current = value;
        }
    };
}
function mergeProps(slotProps, childProps) {
    const merged = { ...childProps };
    for (const key of Object.keys(slotProps)) {
        const slotValue = slotProps[key];
        const childValue = childProps[key];
        if (/^on[A-Z]/.test(key) && typeof slotValue === 'function' && typeof childValue === 'function') {
            merged[key] = (...args) => {
                childValue(...args);
                slotValue(...args);
            };
        }
        else if (key === 'className' && typeof slotValue === 'string' && typeof childValue === 'string') {
            merged[key] = `${childValue} ${slotValue}`.trim();
        }
        else if (key === 'style' && slotValue && childValue) {
            merged[key] = { ...childValue, ...slotValue };
        }
        else {
            merged[key] = slotValue;
        }
    }
    return merged;
}
/**
 * Minimal Radix-style Slot. Clones its single child element and merges slot
 * props onto it, preserving the child's ref.
 */
export function Slot({ children, ...slotProps }) {
    if (!isValidElement(children))
        return null;
    const child = children;
    const merged = mergeProps(slotProps, child.props);
    const mergedRef = mergeRefs(slotProps.ref, child.props.ref);
    return cloneElement(child, { ...merged, ref: mergedRef });
}
//# sourceMappingURL=slot.js.map